import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d9738ade"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9738ade')) {
      api.createRecord('d9738ade', component.options)
    } else {
      api.reload('d9738ade', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=d9738ade", function () {
      api.rerender('d9738ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/premium/list.vue"
export default component.exports